<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Observasi">
            <common-training-header/>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="items.class_sessions"
                rowKey="id"
                :loading="loading"
                :pagination="false"
                :defaultExpandAllRows="true"
                >

                <a-table-column key="class_session" title="Kelas" className="text-small text-left">
                    <template slot-scope="record">
                        {{ record.name }}
                    </template>
                </a-table-column>

                <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
                    <a-table
                        class="pcp-table"
                        :dataSource="record.sessions"
                        rowKey="id"
                        :loading="loading"
                        :pagination="false"
                        bordered
                        >

                        <a-table-column key="title" title="Sesi Pelatihan" className="align-center text-small text-left">
                            <template slot-scope="innerRecord">
                                {{ innerRecord.name }}
                            </template>
                        </a-table-column>

                        <a-table-column key="scheduled" title="Jadwal Mulai" className="align-center text-small text-center">
                            <template slot-scope="innerRecord">
                                {{ moment(innerRecord.session_time_start).format('DD MMMM YYYY HH:mm:ss') }}
                            </template>
                        </a-table-column>

                        <a-table-column key="time_end" title="Jadwal Berakhir" className="align-center text-small text-center">
                            <template slot-scope="innerRecord">
                                {{ moment(innerRecord.session_time_end).format('DD MMMM YYYY HH:mm:ss') }}
                            </template>
                        </a-table-column>

                        <a-table-column key="exam" title="Sesi Ujian" className="align-center text-small text-center">
                            <template slot-scope="innerRecord">
                                <a-icon type="close-circle" theme="twoTone" two-tone-color="#f54242" v-if="innerRecord.class_exam_count == 0" />
                                <a-icon type="check-circle" v-else theme="twoTone" two-tone-color="#52c41a"/>
                            </template>
                        </a-table-column>

                        <a-table-column key="action" title="Status" className="align-center text-small text-center">
                            <template slot-scope="innerRecord">
                                <a-tooltip title="Sesi Kelas">
                                    <a-button
                                        size="small"
                                        icon="ellipsis"
                                        :href="routeUri('admin.classical.class.observation.detail', {
                                            session: innerRecord.id })"
                                    />
                                </a-tooltip>
                            </template>
                        </a-table-column>

                    </a-table>
                </p>
            </a-table>
        </a-card>
    </div>
</template>

<script>

export default {
    props: {
        training: {
            type: Object
        }
    },
    created() {
        this.getItems()
    },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            processing: false,
            visible: false,
            items: {},
        };
    },
    computed: {
        level() {
            switch (window.LaravelRole) {
                case "pm-bk":
                    return 1
                case "po-bk":
                    return 2
                case "pm-client":
                    return 3
                case "po-client":
                    return 4
                default:
                    return 0
            }
        },
    },
    methods: {
        check_level(level) {
            switch (window.LaravelRole) {
                case "pm-bk":
                    if(level == 0)
                        return true
                    else
                        return false
                case "po-bk":
                    if(level == 1)
                        return true
                    else
                        return false
                case "pm-client":
                    if(level == 2)
                        return true
                    else
                        return false
                default:
                    return false
            }
        },
        getItems() {
            this.loading = true

            this.$http
                .get(this.routeUri('api.classical-exam.sessions'))
                .then(response => {
                    this.items = response.data
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
    }
};
</script>


